import { MultipleInputBox } from "./MultipleInputBox";
import { MultipleSelectBox } from "./MultipleSelectBox";

export const ProductMultipleInputs = ({
  label,
  data,
  isSecond = false,
  isSecondData = false,
  secondLabel,
  secondData,
  isError,
  errorText,
  customStyling,
  firstAdditional1stLabel,
  secondAdditional1stLabel,
  firstAdditional2ndLabel,
  secondAdditional2ndLabel,
  customLabelStyle,
}) => {
  return (
    <div className="variation-row-bg" style={{ ...customStyling }}>
      <div>
        <p className="product-detail-text" style={{ ...customLabelStyle }}>
          {label}
        </p>
        {firstAdditional1stLabel && (
          <p className="product-detail-text">{firstAdditional1stLabel}</p>
        )}
        {secondAdditional1stLabel && (
          <p className="product-detail-text">{secondAdditional1stLabel}</p>
        )}
      </div>

      {data &&
        data.map((item) => {
          if (item?.isDropdown === true) {
            return (
              <MultipleSelectBox
                key={item?.name}
                label={item?.name}
                value={item?.value}
                setValue={item?.setValue}
                options={item?.options || []}
                isSecondData={isSecondData}
                secondData={item?.secondData}
                setSecondData={item?.setSecondData}
              />
            );
          } else {
            return (
              <MultipleInputBox
                key={item?.name}
                label={item?.name}
                value={item?.value}
                setValue={item?.setValue}
                type={item?.type}
                customStyle={item?.customStyle}
                secondValue={item?.secondValue}
                secondType={item?.secondType}
                setSecondValue={item?.setSecondValue}
                thirdType={item?.thirdType}
                thirdValue={item?.thirdValue}
                setThirdValue={item?.thirdValue}
                isTextArea={item?.isTextArea}
              />
            );
          }
        })}
      {isSecond === true && (
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div>
            <p className="product-detail-text">{secondLabel}</p>
            {firstAdditional2ndLabel && (
              <p className="product-detail-text">{firstAdditional2ndLabel}</p>
            )}
            {secondAdditional2ndLabel && (
              <p className="product-detail-text">{secondAdditional2ndLabel}</p>
            )}
          </div>
          {secondData &&
            secondData.map((item) => {
              if (item?.isDropdown === true) {
                return (
                  <MultipleSelectBox
                    key={item?.name}
                    label={item?.name}
                    value={item?.value}
                    setValue={item?.setValue}
                    options={item?.options || []}
                  />
                );
              } else {
                return (
                  <MultipleInputBox
                    key={item?.name}
                    label={item?.name}
                    value={item?.value}
                    setValue={item?.setValue}
                    type={item?.type}
                    customStyle={item?.customStyle}
                    secondValue={item?.secondValue}
                    secondType={item?.secondType}
                    setSecondValue={item?.setSecondValue}
                    thirdType={item?.thirdType}
                    thirdValue={item?.thirdValue}
                    setThirdValue={item?.thirdValue}
                    isTextArea={item?.isTextArea}
                  />
                );
              }
            })}
        </div>
      )}
      {isError && (
        <p
          style={{
            fontSize: "10.5px",
            color: "#ED1C24",

            marginTop: "5px",
          }}
        >
          {errorText}
        </p>
      )}
    </div>
  );
};
